import logo from './logo.svg';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import APIManager from './lib/apiManager';
import { useInterval } from './lib/useInterval';
import { Children, useEffect, useState } from 'react';
import { redirect, Route, BrowserRouter as Router, Routes, useNavigate } from 'react-router';
import { doCheckLogin, doLogin } from './lib/auth';
import Swal from 'sweetalert2';
import Plano from './screens/plano';
import Espacios from './screens/espacios';
import Main from './screens/main';

function App() {
  const [usuario, setUsuario] = useState(null);
  const [espacios, setEspacios] = useState([]);

  const [checkDelay, setCheckDelay] = useState(30000); // Delay inicial de 30 segundos

  const [loadingOpen, setLoadingOpen] = useState(false);

  const slotsMock = [
    { id: "A1", row: 0, col: 0, status: "free", label: "A1" },
    { id: "A2", row: 0, col: 1, status: "occupied", label: "A2" },
    { id: "A3", row: 0, col: 2, status: "free", label: "A3" },

    { id: "B1", row: 1, col: 0, status: "blocked", label: "B1" },
    { id: "B2", row: 1, col: 1, status: "free", label: "B2" },

    { id: "C3", row: 2, col: 2, status: "free", label: "C3" },

  ];

  const espaciosMock = [
    { id: "P1", nombre: "Genesis", subtitle: "Cine II", color: '#55BB55', blanco: true, rows: 5, cols: 17, slots: [
    { id: "O1", row: 0, col: 14, status: "free", label: "30" },
    { id: "N1", row: 0, col: 13, status: "occupied", label: "28", visitante: {nombre: 'Visitante 3', documento: '9876543210'} },
    { id: "M1", row: 0, col: 12, status: "free", label: "26" },
    { id: "L1", row: 0, col: 11, status: "free", label: "24" },
    { id: "K1", row: 0, col: 10, status: "free", label: "22" },
    { id: "J1", row: 0, col: 9, status: "free", label: "20" },
    { id: "I1", row: 0, col: 8, status: "occupied", label: "18", visitante: {nombre: 'Visitante 2', documento: '7654321'} },
    { id: "H1", row: 0, col: 7, status: "free", label: "16" },
    { id: "G1", row: 0, col: 6, status: "free", label: "14" },
    { id: "F1", row: 0, col: 5, status: "free", label: "12" },
    { id: "E1", row: 0, col: 4, status: "free", label: "10" },
    { id: "D1", row: 0, col: 3, status: "occupied", label: "8", visitante: {nombre: 'Visitante 1', documento: '1234567'} },
    { id: "C1", row: 0, col: 2, status: "free", label: "6" },
    { id: "B1", row: 0, col: 1, status: "free", label: "4" },
    { id: "A1", row: 0, col: 0, status: "free", label: "2" },

    { id: "O3", row: 2, col: 14, status: "free", label: "29" },
    { id: "N3", row: 2, col: 13, status: "free", label: "27" },
    { id: "M3", row: 2, col: 12, status: "free", label: "25" },
    { id: "L3", row: 2, col: 11, status: "free", label: "23" },
    { id: "K3", row: 2, col: 10, status: "free", label: "21" },
    { id: "J3", row: 2, col: 9, status: "free", label: "19" },
    { id: "I3", row: 2, col: 8, status: "occupied", label: "17", visitante: {nombre: 'Pablo Lopez', documento: '25330104'} },
    { id: "H3", row: 2, col: 7, status: "free", label: "15" },
    { id: "G3", row: 2, col: 6, status: "free", label: "13" },
    { id: "F3", row: 2, col: 5, status: "free", label: "11" },
    { id: "E3", row: 2, col: 4, status: "free", label: "9" },
    { id: "D3", row: 2, col: 3, status: "free", label: "7" },
    { id: "C3", row: 2, col: 2, status: "free", label: "5" },
    { id: "B3", row: 2, col: 1, status: "free", label: "3" },
    { id: "A3", row: 2, col: 0, status: "free", label: "1" },

  ] },
    { id: "P2", nombre: "Choike Aique", subtitle: "Guardería", color: '#CC5555', blanco: true, slots: slotsMock },
    { id: "P3", nombre: "Anexo", subtitle: "Lateral · Sector C", color: '#5555CC', blanco: true, slots: slotsMock },
    { id: "P4", nombre: "mapa 4", subtitle: "Lateral · Sector C", color: '#CCCCCC', blanco: false, slots: slotsMock },
    { id: "P5", nombre: "mapa 5", subtitle: "Lateral · Sector C", color: '#55CCCC', blanco: false, slots: slotsMock },
    { id: "P6", nombre: "mapa 6", subtitle: "Lateral · Sector C", color: '#CCCC55', blanco: false, slots: slotsMock },
    { id: "P7", nombre: "mapa 7", subtitle: "Lateral · Sector C", color: '#333333', blanco: true, slots: slotsMock },
    { id: "P8", nombre: "mapa 8", subtitle: "Lateral · Sector C", color: '#AA33AA', blanco: true, slots: slotsMock },
    { id: "P9", nombre: "mapa 9", subtitle: "Lateral · Sector C", color: '#55CC55', blanco: true, slots: slotsMock },
    { id: "P0", nombre: "mapa 10", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
    { id: "P31", nombre: "mapa 11", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
    { id: "P32", nombre: "mapa 12", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
    { id: "P33", nombre: "mapa 13", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
    { id: "P34", nombre: "mapa 14", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
    { id: "P35", nombre: "mapa 15", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
    { id: "P36", nombre: "mapa 16", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
    { id: "P37", nombre: "mapa 17", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
    { id: "P38", nombre: "mapa 18", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
    { id: "P39", nombre: "mapa 19", subtitle: "Lateral · Sector C", color: '#55CC55', slots: slotsMock },
  ];

  const theme = createTheme({
    palette: {
      primary: {
        main: 'rgba(46, 185, 21, 1)',
        light: 'rgba(84, 245, 66, 1)',
        dark: '#45c015ff',
        contrastText: '#fff',
      }
    }
  });

  const actualizarEspacios = (callback) => {
    // setEspacios(espacios.length > 0 ? [...espacios] : espaciosMock);
    if (!!usuario) {
      APIManager.getList('espacios', { usuarioID: usuario.id }, response => {
        if (response.success) {
          setEspacios(response.data.listado);
        }
      });
    }
  }

  const handleActualizarEspacios = (callback) => {
    actualizarEspacios(callback);
  }

  useEffect(() => {
    if (!usuario) {
      doCheckLogin(null, setUsuario);
    } else {
      actualizarEspacios();
    }
  }, [usuario])

  useInterval(() => {
    doCheckLogin(null, setUsuario);
    if (!!window.sistema?.config?.delayRefresh) {
      setCheckDelay(window.sistema.config.delayRefresh * 1000);
    }
  }, checkDelay)

  useEffect(() => {
    if (!!window.sistema) {
      window.sistema.espacios = espacios;
    }
  }, [espacios]);

  useEffect(() => {
    window.sistema = {};
    actualizarEspacios();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Main espacios={espacios} usuario={usuario} actualizarEspacios={handleActualizarEspacios} setUsuario={setUsuario} setLoadingOpen={setLoadingOpen} />
      </Router>
    </ThemeProvider>
  );
}

export default App;
